import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyH3Props } from "../types";

function TypographyH3({ as, asChild, className, ...props }: TypographyH3Props) {
  const Component = resolveElement(asChild, as, "h3");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.H3] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          scroll-m-20
          ~text-xl/3xl
          font-header font-semibold
          tracking-wide
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyH3;
